import { isContentfulString, isDefined } from '@philips-internal/oswald-ui-utils';
import { applicationContext } from '../context/application-context.js';
import { foundationContext } from '../context/foundation-context.js';
async function getConfiguration() {
    // @ts-expect-error
    const { get } = await import('virtual:oswald-bootstrap');
    return await get();
}
function loadApplicationConfiguration(configuration) {
    if (isContentfulString(configuration.title)) {
        applicationContext.setTitle(configuration.title);
    }
}
function loadFoundationConfiguration(configuration) {
    const togglePairs = [
        [configuration.canEditEstablishment, foundationContext.setCanEditEstablishment],
        [configuration.canEditProfile, foundationContext.setCanEditProfile],
        [configuration.canEditSector, foundationContext.setCanEditSector],
        [configuration.showEstablishment, foundationContext.canShowEstablishment],
        [configuration.showProfile, foundationContext.canShowProfile],
        [configuration.showSector, foundationContext.canShowSector],
        [configuration.moduleSearch?.hideModuleSearch, foundationContext.setHideModuleSearch],
    ];
    for (const [value, fn] of togglePairs) {
        if (isDefined(value)) {
            fn.bind(foundationContext)(value);
            fn.bind(foundationContext)(value);
        }
    }
    if (isContentfulString(configuration.moduleSearch?.expression)) {
        foundationContext.setModuleSearchExpression(configuration.moduleSearch?.expression);
    }
}
function loadFragmentsConfiguration(configuration) {
    if (isContentfulString(configuration.userMenu)) {
        foundationContext.setMenuFragment(configuration.userMenu);
    }
    if (isContentfulString(configuration.root)) {
        foundationContext.setRootFragment(configuration.root);
    }
}
async function loadBootstrapConfiguration() {
    const configuration = await getConfiguration();
    // If array and empty, it means that there's no configuration file.
    if (Array.isArray(configuration) && configuration.length === 0) {
        return;
    }
    if (isDefined(configuration.application)) {
        loadApplicationConfiguration(configuration.application);
    }
    if (isDefined(configuration.foundation)) {
        loadFoundationConfiguration(configuration.foundation);
    }
    if (isDefined(configuration.fragments)) {
        loadFragmentsConfiguration(configuration.fragments);
    }
}
export { loadBootstrapConfiguration, };
//# sourceMappingURL=bootstrap-configuration.js.map